import { SignupChallengeStep } from '@jerry-serverless/enums/user_challenge';

import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';

export const ChallengeDobStep: Step = {
  id: 'challengedob',
  pathname: '/challengedob',
  canShow: (appData) =>
    appData.signupChallengeStep === SignupChallengeStep.Dob ||
    // If it's from the name challenge, then the signupChallengeStep in JWT could still be Name.
    appData.signupChallengeStep === SignupChallengeStep.Name,
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Account,
};
